<template>
  <div class="p-1">
    <div-table :config="configList" @setSelectedCity="setSelectedCity" @Changelimit="Changelimit"
      @searchSellers="searchSellers" :couriers="couriers" :teleconsultants="teleconsultants" :limit="limit"
      @searchCouriers="searchCouriers" :isFilterCourier="isFilterCourier" :statusShippChange="statusShippChange"
      :CourierInfo="CourierInfo" @downloadShippings="downloadShippings" @emtyTabId="emtyTabId"
      @selectAllCheckbox="selectAllCheckbox" @getRowDetail="getRowDetail" :tabId="tabId"
      :CheckQteDefecteuseexist="CheckQteDefecteuseexist" :CheckQteReturnedexist="CheckQteReturnedexist"
      :data="shippings" @CheckQteDefecteuse="CheckQteDefecteuse" @CheckQteReturned="CheckQteReturned" @reset="reset"
      :element="element" :zones="zones" :typesShipp="typesShipp" :statusShipp="statusShipp" @refresh="refresh"
      @filtrer="filtrer" @search="search" :loading="loading" :paidtatus="paidtatus" :paginate="paginate"
      @showProducts="showProducts" :CheckQteDefecteuseorderexist="CheckQteDefecteuseorderexist"
      @CheckQteDefecteuseOrder="CheckQteDefecteuseOrder" @generateListPdf="generateListPdf"
      @paginatation="paginatation"></div-table>
  </div>
</template>

<script>
import 'jspdf-autotable';
import configMA from './configMA';

export default {
  data() {
    return {
      configList: configMA.list,
      loading: false,
      CheckQteDefecteuseexist: false,
      CheckQteReturnedexist: false,
      CheckQteDefecteuseorderexist: false,
      content: {},
      shippings: [],
      tabId: [],
      image: 'https://storeno.b-cdn.net/vex/logo.png',
      couriers: [],
      teleconsultants: [],
      shippingsStockManager: [],
      shippingsLivreur: [],
      filters: {},
      element: {},
      currentUser: {},
      limit: 16,
      sellers: [],
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      CourierInfo: {
        courier: '',
        total: 0,
        count: 0,
      },
      tabIdList: [],
      isFilterCourier: false,
      statusShippSearch: [
        'to prepare',
        'prepared',
        'shipped',
        'delivered',
        'paid',
        'processed',
        'rembourser',
        'cancelled',
        'refused',
        'postponed',
        'unreachable',
        'return',
        'echange',
        'picked up',
        'reprogram',
        'interested',
        'outofstock'
      ],
      statusShipp: [
        'to prepare',
        'prepared',
        'shipped',
        'delivered',
        'processed',
        'rembourser',
        'cancelled',
        'refused',
        'postponed',
        'unreachable',
        'picked up',
        'reprogram',
        'interested',
        'outofstock'
      ],
      statusShippChange: [
        'to prepare',
        'prepared',
        'shipped',
        'delivered',
        'processed',
        'rembourser',
        'cancelled',
        'refused',
        'postponed',
        'unreachable',
        'picked up',
        'reprogram',
        'interested',
        'outofstock'
      ],
      typesShipp: ['pending', 'return'],
      paidtatus: ['pending', 'valid', 'accept'],
      zones: [],
      phoneED: '',
      idWharhouse: null,
      cities: [],
      products: [],
    };
  },
  async mounted() {
    await this.getUser();
    await this.getwharhouseId();
    await this.getSettings();

    if (this.$f.QueryStringToobject()) {
      this.filters = this.$f.QueryStringToobject();
    } else {
      this.$f.objectToQueryString({ limit: this.limit, country: await this.warhouseSelected });
    }

    this.filters = this.$f.QueryStringToobject();

    if (this.filters.name) {
      await this.search(this.filters.name);
    } else {
      await this.getShipping(this.filters);
    }

    this.setDataSelect('category', this.categories, null);

    if (this.currentUser.type == 'Livreur')
      this.statusShippSearch = ['prepared', 'shipped', 'delivered', 'to pick', 'picked', 'refused', 'cancelled'];

    if (this.currentUser.type == 'Accountant') {
      this.statusShippSearch = ['delivered', 'paid'];
    }

    await this.methodeChangeData();
    this.setDataSelect('status', this.statusShippSearch, null);
    this.setDataSelect('delivered_status', ['pending', 'paid', 'return', 'processed'], null,);

    if (this.currentUser.type == 'Seller') {
      this.setDataSelect('delivered_status', ['pending', 'return', 'processed'], null);
    }
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) {
      await this.getwharhouseId();
      await this.getSettings();
      await this.reset();
      await this.methodeChangeData();
      this.isFilterCourier = false;
    },
  },
  methods: {
    async setSelectedCity(id, city) {
      if (id && city) {
        try {
          const { content: orderData } = await this.$server.get('orders', { id });

          if (!orderData) {
            alert(this.$t('order_not_found'), 'warning');
            return;
          }

          const { fees, zone } = await this.getFeesShipByCity(city);

          orderData.customer.city = city;
          orderData.feesShip = fees;
          orderData.zone = zone;

          const confirmed = await this.$confirm(`Are you sure you want to update city?`);
          if (!confirmed) return;

          const response = await this.$server.update('orders', orderData);

          if (response && response._id) {
            alert(this.$t('order_updated'), 'success');
            this.refresh();
          } else {
            alert(this.$t('update_failed'), 'warning');
          }
        } catch (error) {
          console.error("Error in setSelectedCity:", error);
          alert(error.message || this.$t('unexpected_error'), 'warning');
        }
      }
    },
    async getFeesShipByCity(city) {
      if (!city) return { fees: 0, zone: 0 };

      try {
        const { content } = await this.$server.search('zones', { cities: city });
        const zoneData = content.results[0];

        if (zoneData) {
          const { price: fees, _id: zone } = zoneData;
          return { fees, zone };
        }
      } catch (error) {
        console.error("Error in getFeesShipByCity:", error);
      }

      return { fees: 0, zone: 0 };
    },
    async getSettings() {
      if (this.currentUser.type != 'Seller') {
        const dataWahrhouse = await this.$server.get('settings', {
          warehouse: this.idWharhouse._id,
        });
        if (dataWahrhouse.content.length > 0) {
          const currentSettingW = this.getElementInArray(
            dataWahrhouse.content[0].details,
            this.idWharhouse._id,
          );
          if (currentSettingW && currentSettingW.phone)
            this.phoneED = currentSettingW.phone;
        }
      }
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    getElementInArray(data, value) {
      if (value) {
        var result = data.filter(function (o) {
          if (o && o.warehouse) {
            let whar = o.warehouse;
            if (o.warehouse._id) whar = o.warehouse._id;
            return whar === value.toString();
          } else return null;
        });
        return result ? result[0] : null;
      } else return null;
    },
    async getCities(country) {
      const resCities = await this.$server.get('zones', {
        allCities: true,
        country: country,
      });

      if (resCities.content.length > 0) this.cities = resCities.content;
      else this.cities = [];
    },
    changeFilterFileds() {
      const { type } = this.currentUser;
      const userTypesToFilter = ['TeleConsultant', 'Courier'];
      const keysToExclude = [
        'seller', 'api_status', 'product', 'affiliate_stores',
        'courier', 'teleconsultant', 'city', 'Facture_date',
        'from', 'to'
      ];

      if (userTypesToFilter.includes(type)) {
        this.configList.filters.elements.champs = this.configList.filters.elements.champs.filter(
          ({ key }) => !keysToExclude.includes(key)
        );
      }
    },
    async methodeChangeData() {
      if (this.currentUser.type !== 'Seller') {
        await this.getCouriers('Courier');
        await this.getCouriers('TeleConsultant');

        await this.getZones();
        await this.getSellers();

        await this.getProducts();
        this.setDataSelect('seller', this.sellers, null);

        this.setDataSelect('product', this.products, null);
        this.changeFilterFileds();
      } else {
        let pos = this.configList.columns.map(function (e) { return e.name; }).indexOf('seller');
        if (pos != -1) this.configList.columns.splice(pos, 1);

        const dataWhrahouseSetting = this.getElementInArray(this.currentUser.settings, this.idWharhouse._id);
        let posC = this.configList.columns.map(function (e) { return e.name; }).indexOf('courier');

        if (posC != -1) this.configList.columns.splice(posC, 1);
        let posT = this.configList.columns.map(function (e) { return e.name; }).indexOf('teleconsultant');

        if (posT != -1) this.configList.columns.splice(posT, 1);
      }

      if (this.couriers) {
        const defaultCourier = {
          _id: "no_courier",
          fullName: "No Courier",
        };
        const filterCouriers = [defaultCourier, ...this.couriers];
        this.setDataSelect('courier', filterCouriers, null);
      }

      this.setDataSelect('teleconsultant', this.teleconsultants, null);
      this.setDataSelect('zone', this.zones, null);

      await this.getCities(await this.warhouseSelected);
      this.setDataSelect('city', this.cities, null);

      let pos1 = this.configList.columns.map(function (e) { return e.name; }).indexOf('zone');
      if (pos1 != -1) this.configList.columns.splice(pos1, 1);
    },
    async CheckQteDefecteuseOrder(item) {
      this.CheckQteDefecteuseorderexist = false;
      if (item.type == 'return') {
        for (let i in item.order.details) {
          const filters = {
            product: item.order.details[i].product._id,
            order: item.order._id,
            shipping: item._id,
          };
          const res = await this.$server.search('stockHistories', filters);

          if (typeof res.content.results !== 'undefined') {
            item.order.details[i].product.qteChange =
              res.content.results[0].quantity;
            this.CheckQteDefecteuseorderexist = true;
          }
        }
      }
    },
    async Changelimit(val) {
      if (this.$f.QueryStringToobject()) {
        this.filters = this.$f.QueryStringToobject();
      }

      this.filters['limit'] = val;
      this.filters['page'] = 1;

      this.paginate.currentpage = 1;
      this.$f.objectToQueryString(this.filters);

      if (this.filters.name) await this.search(this.filters.name);
      else await this.getShipping(this.filters);
    },
    sumQteProduct(data) {
      let sum = 0;
      for (let i in data) {
        sum = sum + data[i].quantity;
      }
      return sum;
    },
    sumProduct(data) {
      let product = '';
      for (let i in data) {
        product += data[i].product.name;
        if (data.length - 1 != i) product += ' ,';
      }
      return product;
    },
    async downloadShippings() {
      var arr = typeof this.shippings !== 'object' ? JSON.parse(this.shippings) : this.shippings;

      for (let i in arr) {
        arr[i].ShippingAddress = arr[i].address ? arr[i].address : '';
        arr[i].ShippingDate = this.$moment(arr[i].date).format('yyyy-MM-DD HH:mm');
        arr[i].FullName = arr[i].order.customer.fullName;
        arr[i].Phone = arr[i].order.customer.phone;
        arr[i].Phone2 = arr[i].order.customer.shippingPhone ? arr[i].order.customer.shippingPhone : '';
        arr[i].Order = this.sumProduct(arr[i].order.details);
        arr[i].TrakingNumber = arr[i].trackingNumber;
        arr[i].Status = arr[i].status;
      }

      for (let j in arr) {
        delete arr[j].courier;
        delete arr[j].createdAt;
        delete arr[j].address;
        delete arr[j].date;
        delete arr[j].isDeleted;
        delete arr[j].order;
        delete arr[j].price;
        delete arr[j].seller;
        delete arr[j].status;
        delete arr[j].trackingNumber;
        delete arr[j]._id;
        delete arr[j].type;
        delete arr[j].zone;
        delete arr[j].__v;
      }
      //
      let str = `${Object.keys(arr[0]).map(value => `"${value}"`).join(',')}` + '\r\n';
      let csvContent = arr.reduce((st, next) => {
        st += `${Object.values(next).map(value => `"${value}"`).join(',')}` + '\r\n';
        return st;
      }, str);

      let element = document.createElement('a');
      element.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent);

      element.target = '_blank';
      element.download = 'shippings.csv';

      element.click();
      await this.getShipping({ limit: this.limit });
    },
    selectAllCheckbox($event) {
      let columns = document.querySelectorAll('.rowCheckbox');
      this.tabId = [];
      if ($event.target.checked == true) {
        columns.forEach(column => {
          column.checked = true;
          this.tabId.push({
            id: column.id,
            source: column.getAttribute('seller'),
            externalId: column.getAttribute('externalId'),
            trackingNumber: column.getAttribute('trackingNumber'),
            date: column.getAttribute('date'),
            courier: column.getAttribute('courier'),
            typeshipp: column.getAttribute('typeshipp'),
            order: column.getAttribute('order'),
            status: column.getAttribute('status'),
            orderobjet: column.getAttribute('orderobjet'),
          });
        });
      } else {
        columns.forEach(column => { column.checked = false; });
        this.tabId = [];
      }
    },
    getRowDetail(item, id) {
      let itemInRow = this.tabId.filter(item => item.id === id);
      let isItemInRow = itemInRow.length > 0;

      if (isItemInRow) {
        let pos = this.tabId.map(function (e) { return e.id; }).indexOf(id);
        this.tabId.splice(pos, 1);
      } else {
        this.tabId.push({
          id: id,
          source: item.seller.source ? item.seller.source : item.seller.company || 'nosource',
          externalId: item.order.externalId || item.externalId,
          order: item.order._id,
          status: item.status,
          typeshipp: item.type,
          courier: item.courier,
          trackingNumber: item.trackingNumber,
          date: item.date,
          orderobjet: JSON.stringify(item.order),
        });
      }

      if (this.tabId.length === 0) {
        let columns = document.querySelectorAll('.checkallbbox');
        columns.forEach(column => {
          column.checked = false;
        });
      }
    },
    emtyTabId() {
      let columns = document.querySelectorAll('.rowCheckbox');
      columns.forEach(column => {
        column.checked = false;
      });
      this.tabId = [];
    },
    async getCouriers(type) {
      const filter = {
        type: type === 'TeleConsultant' ? ['TeleConsultant', 'StockManager', 'Admin'] : type,
        status: 'active',
        countries: await this.warhouseSelected,
        limit: this.limit,
      };

      const res = await this.$server.find('users', filter);

      if (res.content.results) {
        if (type === 'Courier') this.couriers = res.content.results;
        if (type === 'TeleConsultant') this.teleconsultants = res.content.results;
      } else {
        if (type === 'Courier') this.couriers = [];
        if (type === 'TeleConsultant') this.teleconsultants = [];
      }
    },
    searchCouriers: _.debounce(async function (search, type) {
      const filter = {
        type: type === 'TeleConsultant' ? ['TeleConsultant', 'StockManager', 'Admin'] : type,
        limit: this.limit,
        status: 'active',
        countries: await this.warhouseSelected,
        name: search
      };
      const res = await this.$server.find('users', filter);
      if (res.content.results) {
        if (type === 'Courier') this.couriers = res.content.results;
        if (type === 'TeleConsultant') this.teleconsultants = res.content.results;
      } else {
        if (type === 'Courier') this.couriers = [];
        if (type === 'TeleConsultant') this.teleconsultants = [];
      }

      if (type === 'Courier') {
        this.setDataSelect('courier', this.couriers, null);
      }

      if (type === 'TeleConsultant') {
        this.setDataSelect('teleconsultant', this.teleconsultants, null);
      }
    }, 500),
    searchSellers: _.debounce(async function (search, event) {
      const filter = {
        type: 'Seller',
        limit: this.limit,
        countries: await this.warhouseSelected,
        name: search,
      };

      const res = await this.$server.find('users', filter);

      if (res && res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
      this.setDataSelect('seller', this.sellers, null);
    }, 500),
    async getSellers() {
      const filter = {
        type: 'Seller',
        countries: await this.warhouseSelected,
        limit: 16,
      };

      const res = await this.$server.search('users', filter);
      if (res && res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    },
    async getProducts(filters) {
      const filter = {
        'details.warehouse': this.idWharhouse._id,
      };

      const res = await this.$server.search('products', filter);

      if (res.content.results) this.products = res.content.results;
      else this.products = [];
    },
    async getZones() {
      const res = await this.$server.search('zones', {
        country: await this.warhouseSelected,
        limit: 1000,
      });

      if (res.content.results) this.zones = res.content.results;
      else this.zones = [];
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (this.configList.filters.elements.champs[i].type === 'select' && this.configList.filters.elements.champs[i].key === model) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    setUserId(filters) {
      return (filters.seller = this.currentUser._id);
    },
    showProducts(index) {
      if (this.element !== this.shippings[index]) {
        this.element = this.shippings[index];
      } else this.element = null;
    },
    async CheckQteDefecteuse(item) {
      this.CheckQteDefecteuseexist = false;
      if (item.type == 'change') {
        for (let i in item.order.details) {
          const filters = {
            product:
              item.order.details[i].product._id ||
              item.order.details[i].product,
            order: item.order._id,
            shipping: item._id,
          };

          const res = await this.$server.search('stockHistories', filters);

          if (typeof res.content.results !== 'undefined') {
            item.order.details[i].product.qteChange =
              res.content.results[0].quantity;
            this.CheckQteDefecteuseexist = true;
          }
        }
      }
    },
    async CheckQteReturned(item) {
      this.CheckQteReturnedexist = false;
      if (item.type == 'return') {
        for (let i in item.order.details) {
          const filters = {
            product: item.order.details[i].product._id,
            order: item.order._id,
            shipping: item._id,
          };
          const res = await this.$server.search('stockHistories', filters);
          if (typeof res.content.results !== 'undefined') {
            item.order.details[i].product.qteChange =
              res.content.results[0].quantity;
            this.CheckQteReturnedexist = true;
          }
        }
      }
    },
    async getPhoneDelevry(data) {
      for (const element of data) {
        element.date = this.$moment(element.date).format('yyyy-MM-DD');

        const orderId = element.orderObjet ? element.orderObjet.id : '';
        element.order_id = orderId;

        element.totalPrice = element.order.totalPrice;
        element.source = element.order.source;

        element.authorize_package = false;
        let dataWhrahouseSetting = null;

        if (element.seller && element.seller.settings && element.seller.settings.length > 0) {
          dataWhrahouseSetting = this.getElementInArray(
            element.seller.settings,
            this.idWharhouse._id,
          );
        }

        if (dataWhrahouseSetting && dataWhrahouseSetting.shipping) {
          element.phone = this.phoneED;
        } else {
          element.phone = element.seller.phone;
        }

        if (dataWhrahouseSetting) {
          element.authorize_package = dataWhrahouseSetting.open_colis;
        }
      }
    },
    async getShipping(filters) {
      if (this.currentUser.type == 'Seller') {
        let pos = this.configList.columns.map(function (e) { return e.name; }).indexOf('seller');
        if (pos != -1) this.configList.columns.splice(pos, 1);

        let posC = this.configList.columns.map(function (e) { return e.name; }).indexOf('courier');
        if (posC != -1) this.configList.columns.splice(posC, 1);
      }

      this.loading = true;

      filters.country = await this.warhouseSelected;
      const res = await this.$server.search('shippings', filters);
      this.loading = false;

      if (res.content.results) {
        await this.getPhoneDelevry(res.content.results);
        this.shippings = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.shippings = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }

      if (this.isFilterCourier) {
        this.CourierInfo.total = 0;
        const rescourier = await this.$server.search('shippings', filters);
        if (rescourier.content.results) {
          this.CourierInfo.count = rescourier.content.results.length;
          for (const element of rescourier.content.results) {
            this.CourierInfo.total += element.order.totalPrice;
          }
        }
      }
    },
    async getUserByid(id) {
      const filters = {
        _id: id,
      };

      const res = await this.$server.find('users', filters);
      if (res.content) {
        return res.content[0].email;
      }
    },
    async getShippingStockManager() {
      const filters = {
        status: 'to prepare',
        dateShipp: this.$moment(Date.now()).format('yyyy-MM-DD'),
        country: await this.warhouseSelected,
      };

      const res = await this.$server.search('shippings', filters);

      if (res.content.results) {
        this.shippingsStockManager = res.content.results;
      } else this.shippingsStockManager = [];
    },
    async getShippingLivreur() {
      const filters = {
        status: 'prepared',
        dateShipp: this.$moment(Date.now()).format('yyyy-MM-DD'),
        country: await this.warhouseSelected,
      };

      const res = await this.$server.search('shippings', filters);

      if (res.content.results) {
        this.shippingsLivreur = res.content.results;
      } else this.shippingsLivreur = [];
    },
    async refresh() {
      this.emtyTabId();
      if (this.$f.QueryStringToobject()) {
        this.filters = this.$f.QueryStringToobject();
      }

      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else await this.getShipping(this.filters);

      this.isFilterCourier = false;
      if (this.filters['page'] && this.filters['page'] > 1 && this.shippings.length == 0) {
        this.filters['page'] = --this.filters['page'];
        this.$f.objectToQueryString(this.filters);
        await this.getShipping(this.filters);
      }
    },
    async reset(data) {
      this.emtyTabId();
      let lmitt = this.limit;
      if (this.$f.QueryStringToobject()) {
        this.filters = this.$f.QueryStringToobject();
      }

      if (this.filters['limit']) {
        lmitt = this.filters['limit'];
      }

      this.filters['page'] = 1;

      this.$f.objectToQueryString({
        limit: lmitt,
        country: await this.warhouseSelected,
      });

      this.isFilterCourier = false;
      await this.getShipping({ limit: lmitt });
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      let limitt = this.limit;

      if (this.filters['limit']) limitt = this.filters['limit'];
      const search = { name: data.trim(), limit: parseInt(limitt) };

      search.country = await this.warhouseSelected;
      this.$f.objectToQueryString(search);

      const res = await this.$server.find('shippings', search);

      if (res.content.results) {
        await this.getPhoneDelevry(res.content.results);
        this.shippings = res.content.results;
        this.shippings.total = res.content.total;
        this.shippings.lastpage = res.content.last_page;
        this.shippings.per_page = res.content.per_page;
        this.shippings.currentpage = res.content.current_page;
      } else {
        this.shippings = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async filtrer(data) {
      if (this.$f.QueryStringToobject()) {
        this.filters = this.$f.QueryStringToobject();
      }

      delete this.filters.page;
      delete this.filters.name;

      if (!this.filters['limit']) {
        this.filters['limit'] = this.limit;
      }

      if (data.status) {
        this.filters.status = data.status;
      } else {
        delete this.filters.status;
      }

      if (data.teleconsultant) {
        this.filters['orderObjet.teleConsultantConfirm._id'] = data.teleconsultant._id;
      } else {
        delete this.filters['orderObjet.teleConsultantConfirm._id'];
      }

      if (data.payment) {
        this.filters.payment = data.payment;
      } else {
        delete this.filters.payment;
      }

      if (data.Publisher_number) {
        this.filters['orderObjet.Publisher_number'] = data.Publisher_number;
      } else {
        delete this.filters['orderObjet.Publisher_number'];
      }

      if (data.totalPrice) {
        this.filters['orderObjet.totalPrice'] = data.totalPrice;
      } else {
        delete this.filters['orderObjet.totalPrice'];
      }

      if (data.affiliate_stores) {
        this.filters.ThirdParty = data.affiliate_stores;
      } else {
        delete this.filters.ThirdParty;
      }

      if (data.api_status) {
        this.filters.api_status = data.api_status;
      }
      else {
        delete this.filters.api_status;
      }

      if (data.Range_date) {
        this.filters.Range_date = data.Range_date.map(el =>
          this.$moment(el).format('yyyy-MM-DD'),
        );
      } else {
        delete this.filters.Range_date;
      }

      if (data.Facture_date) {
        this.filters.Facture_date = data.Facture_date.map(el =>
          this.$moment(el).format('yyyy-MM-DD'),
        );
      } else {
        delete this.filters.Facture_date;
      }

      if (data.from && data.to) {
        delete this.filters.date;
        this.filters.from = data.from;
        this.filters.to = data.to;
      } else {
        delete this.filters.from;
        delete this.filters.to;
      }

      if (data.city) {
        this.filters.city = data.city;
      } else {
        delete this.filters.city;
      }

      this.paginate.currentpage = 1;
      if (data.seller) {
        this.filters.seller = data.seller._id;
      } else {
        delete this.filters.seller;
      }

      if (data.product) {
        this.filters.product = data.product._id;
      } else {
        delete this.filters.product;
      }

      if (data.delivered_status) {
        this.filters.delivered_status = data.delivered_status;
      } else {
        delete this.filters.delivered_status;
      }

      if (data.zone) {
        this.filters.zone = data.zone._id;
      } else {
        delete this.filters.zone;
      }

      if (data.courier) {
        if (this.currentUser.type == 'Admin' || this.currentUser.type == 'CEO' || this.currentUser.type == 'Accountant') {
          this.isFilterCourier = true;
          this.CourierInfo.courier = data.courier.email;
        }
        this.filters.courier = data.courier._id;
      } else {
        delete this.filters.courier;
      }

      this.$f.objectToQueryString(this.filters);
      await this.getShipping(this.filters);
    },
    async getUser() {
      const res = await this.$server.me('users');
      if (res.content) {
        this.currentUser = res.content;
      } else {
        this.currentUser = [];
      }
    },
    async paginatation(direction) {
      var page = 0;
      if (direction == 'next') {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }

      if (this.$f.QueryStringToobject()) {
        this.filters = this.$f.QueryStringToobject();
      }

      this.filters['page'] = page;
      this.$f.objectToQueryString(this.filters);

      this.getShipping(this.filters);
    },
    generateListPdf() {
      this.tabIdList = [];
      for (let i in this.tabId) {
        this.tabIdList.push(this.tabId[i].id);
      }

      if (this.tabIdList.length == 0) {
        alert(`No Shipping selected !`, 'warning');
        return false;
      }

      var tableheader = '<div class="w-full" style="page-break-after: avoid; page-break-before: avoid;">';
      tableheader += '<table style="margin:10px;margin-top:0;width: 100%;"><tbody class="bg-white">';

      tableheader += '<tr class="w-full"><td class="align-top font-bold"  style="font-size: 0.70rem;line-height: 1rem;width: 50% !important;border: none !important;"><span>Nombre de commande : ' + this.tabIdList.length + '</span><br><span>Date : ' + this.$moment(this.shippings[0].date).format('yyyy-MM-DD') + '</span></td>';
      tableheader += '<td class="align-top text-right" style="width: 50% !important;border: none !important;"><img style="width:40%;" alt="..." class="rounded-full align-middle border-none" src="' + this.image + '"/></td></tr>';

      tableheader += '</tbody></table>';
      tableheader += '<table class="w-full">';

      tableheader += '<thead class="justify-between">';
      tableheader += '<tr class="border border-black">';

      tableheader += '<th style="font-size: 0.60rem;line-height: 1.20rem;" class="px-2 text-center leading-4 text-black tracking-wider"> <span class="text-black">' + this.$t('order') + '</span></th>';
      tableheader += '<th style="font-size: 0.60rem;line-height: 1.20rem;"  class="px-2 text-center text-xs leading-4 text-black tracking-wider"><span class="text-black">Traking</span></th>';

      tableheader += '<th style="font-size: 0.60rem;line-height: 1.20rem;"  class="px-2 text-center text-xs leading-4 text-black tracking-wider"><span class="text-black">' + this.$t('city') + '</span></th>';
      tableheader += '<th style="font-size: 0.60rem;line-height: 1.20rem;"  class="px-2 text-center text-xs leading-4 text-black tracking-wider"><span class="text-black">' + this.$t('store') + '</span></th>';

      tableheader += '<th style="font-size: 0.60rem;line-height: 1.20rem;"  class="px-2 text-center text-xs leading-4 text-black tracking-wider"><span class="text-black">' + this.$t('quantity') + '</span></th>';
      tableheader += '<th style="font-size: 0.60rem;line-height: 1.20rem;"  class="px-2 text-center text-xs leading-4 text-black tracking-wider"><span class="text-black">' + this.$t('price') + '</span></th>';

      tableheader += '<th style="font-size: 0.60rem;line-height: 1.20rem;"  class="px-2 text-center text-xs leading-4 text-black tracking-wider"><span class="text-black">Bareode</span></th>';
      tableheader += '</tr></thead><tbody class="bg-white w-full">';

      var tablefooter = '</tbody></table></div>';

      var printContents = '';
      printContents += tableheader;

      for (let i in this.tabIdList) {
        let modalPr_id = 'ModalprintList_' + this.tabIdList[i];
        printContents += document.getElementById(modalPr_id).innerHTML;
      }

      printContents += tablefooter;

      var mywindow = window.open('', 'PRINT', 'height=400,width=600');
      mywindow.document.write('<html lang="en"><head><meta charset="utf-8"><title>DELIVRY NOTE</title>');
      mywindow.document.write('<style type="text/css">.m-2{margin:4mm}.barcode-img img{width: 150px;height:20px}.overflow-visible{white-space: initial;}.trakingn img{width: 50%;}.mb-0{margin-bottom: 0px;}.w-1/4{width: 25%;}.w-3/4{width: 75%;}.m-0{margin:0}.pt-0{padding-top: 0px;}.mt-0{margin-top: 0px;}.py-1{padding-top: 0.25rem;padding-bottom: 0.25rem;}.px-3{padding-left: 0.75rem;padding-right: 0.75rem;}.w-2/4{width: 50%;}.mt-1{margin-top: 0.25rem;}.align-top{vertical-align: top;}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width:10rem}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>');

      mywindow.document.write('</head><body class="border border-black" style="margin:10mm;padding:5mm">');
      mywindow.document.write(printContents);

      mywindow.document.write('</body></html>');
      mywindow.document.close();

      mywindow.focus();

      setTimeout(function () {
        mywindow.print();
        mywindow.close();
      }, 500);
      return false;
    },
  },
};
</script>
